import React, { useContext } from "react";
import ResultContainer from "../Results/ResultContainer";
import Result from "../Results/Result.jsx";
import NavPanel from "../Common/Nav/NavPanel.jsx";
import UpdatePanelContainer from "../LastUpdated/UpdatePanelConainer";
import CalendarContainer from "../Calendar/CalendarContainer";
import { IsMobileContext } from "../isMobileContext";
import {FormattedMessage} from 'react-intl';

const RankingsNav = ({
  game,
  strings,
  general,
  current,
  stages,
  onClassificationClick,
  result,
  marked,
  onSubleagueClick,
}) => {
  const ctx = useContext(IsMobileContext);

  if (!game || !strings) {
    return null;
  }

  return (
    <section>
      {ctx.isMobile ? null : <UpdatePanelContainer />}
      {ctx.isMobile ? null : (
        <FormattedMessage id="ranking.subleagues">
          {(subleaguesName) => (
            <FormattedMessage id="ranking.subleaguesOpen">
              {(subleaguesOpen) => (
                <FormattedMessage id="ranking.classifications">
                  {(message) => (
                    <NavPanel
                      name={message}
                      items={general.concat([
                        {
                          id: "prize",
                          type: "subleagues",
                          name: subleaguesName,
                        },
                      ])}
                      onClick={(item) => {
                        switch (item.type) {
                          case "classification--general":
                            onClassificationClick(item);
                            break;
                          case "subleagues":
                            onSubleagueClick(item.id, game);
                        }
                      }}
                      current={current}
                    />
                  )}
                </FormattedMessage>
              )}
            </FormattedMessage>
          )}
        </FormattedMessage>
      )}

      {stages && stages.length >= 1 ? (
        <NavPanel
          name={strings.stages}
          moreText={strings.moreStages}
          items={stages}
          onClick={onClassificationClick}
          current={current}
          showPerPage={6}
        />
      ) : null}

      <ResultContainer result={result} marked={marked} current={current} game={game} />

      <CalendarContainer />
    </section>
  );
};
export default RankingsNav;
